import React from "react";
import { useMutation } from "@tanstack/react-query";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, TextField } from "@mui/material";
import { toast } from "react-toastify";
import organizationservice from "../../../service/organizationservice";
import errorHandler from "../../../utils/errorHandler";

const FirsBusinessLimitDialog = ({ isOpen, onClose, organizationId, maxBusinesses, businessCount, onSaved, footer }) => {
  const [limit, setLimit] = React.useState("1");
  const [isUnlimited, setIsUnlimited] = React.useState(false);

  React.useEffect(() => {
    if (!isOpen) return;
    setIsUnlimited(maxBusinesses === null);
    setLimit(String(maxBusinesses ?? 1));
  }, [isOpen, maxBusinesses]);

  const limitMutation = useMutation({
    mutationFn: () => organizationservice.updateFirsBusinessLimit(organizationId, isUnlimited ? null : Number(limit)),
    onError: ({ response }) => errorHandler(response),
    onSuccess: () => {
      toast.success("Business limit updated successfully.");
      onClose();
      onSaved?.();
    },
  });

  const isLimitValid = isUnlimited || (Number.isInteger(Number(limit)) && Number(limit) >= 1);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>NRS Business Limit</DialogTitle>
      <Divider />
      <DialogContent>
        <p className="fs-sm text-secondary mb-2">
          {businessCount ?? 0} {businessCount === 1 ? "business" : "businesses"} in use.
        </p>
        <FormControlLabel
          control={<Checkbox checked={isUnlimited} onChange={(e) => setIsUnlimited(e.target.checked)} />}
          label="Unlimited"
        />
        <TextField
          fullWidth
          size="small"
          type="number"
          label="Business limit"
          value={limit}
          disabled={isUnlimited}
          inputProps={{ min: 1 }}
          helperText="Lowering the limit keeps current businesses and only blocks new ones."
          onChange={(e) => setLimit(e.target.value)}
          sx={{ my: 2 }}
        />
        {footer}
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Close
        </Button>
        <Button variant="contained" disabled={!isLimitValid || limitMutation.isPending} onClick={() => limitMutation.mutate()}>
          {limitMutation.isPending ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FirsBusinessLimitDialog;
